declare var window: {
  outputUI: Function,
  createMap: Function,
  fitBounds: Function,
  openTooltipForFeature: Function,
};

declare var Sentry: {
  captureMessage: Function,
};

declare var mapboxgl: any;

import { template } from '../../vendor/lodash.template';
import getGeoLocationFeature from '../../maps/helpers/getGeoLocationFeature';

const $toolbar = $('.js-map-overlay-toolbar');
const $map = $('.js-map-overlay-map');

let features;

const templates: {
  assets: any,
  toolbar: any,
} = {
  assets: '',
  toolbar: '',
};

let map;

/**
 * Render categories to the toolbar
 * @param {Array} features
 * @return {string}
 */
function renderToolbar(features: any) {
  return templates.toolbar({ features });
}

/**
 * Create a map instance
 * @return {Map}
 */
function renderMap() {
  return window.createMap($map.get(0));
}

/**
 * Render GeoJSON features to the map
 * @param {Map} map
 * @param {Array} features
 * @return {void}
 */
function renderPointsToMap(map: any, features: any) {
  if (typeof map === 'undefined' || typeof map.getSource !== 'function') {
    return;
  }

  // If we've already set a data source, we only have to update it's data
  if (typeof map.getSource('geojson') !== 'undefined') {
    map.getSource('geojson').setData({ features: features });
    return;
  }

  map.addLayer({
    id: 'geojson',
    type: 'symbol',
    source: {
      type: 'geojson',
      data: {
        features: features,
      },
      cluster: true,
      clusterRadius: 75,
    },
  });
}

/**
 * Focus the map on a GeoJSON feature by id
 * @param {string|number} id
 * @return {void}
 */
export function focusOnPoint(id: number|string) {
  let foundItem;

  if (typeof map === 'undefined') {
    return;
  }

  features.forEach((item: any) => {
    if (item.id === id) {
      foundItem = item;
    }
  });

  if (
    typeof foundItem === 'undefined'
    || Number.isNaN(parseFloat(foundItem.properties.lng))
  ) {
    if (typeof Sentry !== 'undefined') {
      Sentry.captureMessage('A foundItem is undefined or doesn\'t contain LatLng props');
    }
    return;
  }

  const LngLat: typeof mapboxgl.LngLat = mapboxgl.LngLat;

  const latLng = new LngLat(
    parseFloat(foundItem.properties.lng),
    parseFloat(foundItem.properties.lat),
  );

  map.setCenter(latLng);
  map.setZoom(7);

  setTimeout(
    () => {
      // Find all features on this geolocation
      const features = map.queryRenderedFeatures(map.project(latLng));

      // Filter the features down to just the ones in our GeoJSON data
      const locationFeature: any[] = getGeoLocationFeature(features);

      if (locationFeature.length) {
        window.openTooltipForFeature(map, locationFeature[0]);
      }
    },
    200,
  );
}

/**
 * Highlight the clicked item on the map in the toolbar
 * @param {string|number} id
 * @return {void}
 */
function highlightInToolbar(id) {
  $toolbar.find('.map-overlay__places button.is-active').removeClass('is-active');
  $toolbar.find(`.map-overlay__place-btn[data-id="${id}"]`).addClass('is-active');
}

export default (res: any) => {
  // Store templates
  templates.assets = template($('#map-overlay-assets').html());
  templates.toolbar = template($('#map-overlay-toolbar').html());

  // Group all GeoJSON features into labeled categories
  features = res.features;

  $toolbar.html(renderToolbar(features));

  // Create a Mapbox map
  map = renderMap();

  // Change the map bounds to the one given by our GeoJSON API
  window.fitBounds(map, res.bounds, 5);

  // If the map is ready we render the items and output the clusters and points
  map.on('load', () => {
    if (typeof features !== 'undefined' && features) {
      renderPointsToMap(map, features);
    }
    window.outputUI(map);
  });

  // Handle clicks on points on the map
  map.on('click', 'unclustered_point', (e: any) => {
    // Find all features on the clicked position
    const features: any = map.queryRenderedFeatures(e.point);

    // Filter the features down to just the ones in our GeoJSON data
    const locationFeature: any[] = getGeoLocationFeature(features);

    if (locationFeature.length) {
      highlightInToolbar(locationFeature[0].properties.id);
    }
  });
};
